import { configChangeTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_CONFIG_CHANGE, SET_CONFIG_CHANGE_FILTERS, RESTORE_INITIAL } = configChangeTypes;

const initialState = {
    configChange: [],
    serie: 0,
    stationary: 0,
    station: null,
};

export const configChangeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_CONFIG_CHANGE:
            return { ...state, configChange: payload };
        case SET_CONFIG_CHANGE_FILTERS:
            return {
                ...state,
                [payload.key]: payload.value
            }
        case RESTORE_INITIAL:
            return initialState
        default:
            return state;
    }
};